import { IActionGroup, IStore } from '../index';
import { IAvatarStore } from './store';

export interface IAvatarActions {
  setBase64: (base64: string) => { avatar: IAvatarStore };
  setClubBase64: (clubBase64: string) => { avatar: IAvatarStore };
}

const actions: IActionGroup = {
  setBase64: (state: IStore, base64: string): { avatar: IAvatarStore } => {
    const { avatar } = state;
    return {
      avatar: {
        ...avatar,
        base64
      }
    };
  },
  setClubBase64: (state: IStore, clubBase64: string): { avatar: IAvatarStore } => {
    const { avatar } = state;
    return {
      avatar: {
        ...avatar,
        clubBase64
      }
    };
  }
};

export default actions;
